export const LoginModalId = 'login';
export const SignUpModalId = 'signup';
export const USER_AGREEMENT_MODAL_ID = 'agreement';
export const FORGOT_PASSWORD_MODAL_ID = 'forgot';
export const PROFILE_EDIT_EMAIL_MODAL_ID = 'profile-email';
export const PROFILE_EDIT_PASSWORD_MODAL_ID = 'profile-password';
export const PROFILE_EDIT_WALLET_MODAL_ID = 'profile-wallet';

export const MINIMAL_PAYOUT_THRESHOLD = 0.005;
export const API_CODE_LENGTH = 6;
export const MINING_ADDRESS = 'pool.knoxpool.com:3333';

export const VerificationCodeType = {
  ACTIVATE_ACCOUNT: 'ACTIVATE_ACCOUNT',
  RESET_PASSWORD: 'RESET_PASSWORD',
  UPDATE_FRAGILE_DATA: 'UPDATE_FRAGILE_DATA',
  VERIFY_NEW_EMAIL: 'VERIFY_NEW_EMAIL',
};



// WEBPACK FOOTER //
// /src/services/constants.js